import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/cancel-order-list',
      name: 'admin-cancel-order-list',
      component: () => import(/* webpackChunkName: "page-admin-credit-management-cancel-order-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "砍单订单列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "授信管理"
                                        },
                                        {
                                                  name: "砍单订单列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
